
import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SMSService } from 'src/app/services/SMS/sms.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  Submitted: boolean = false;
  GroupList: any;
  GroupDeopDownList: any;
  GroupContactList: any;
  ContactSubmitted:boolean=false;

  constructor(private SmsService: SMSService, private LookupService: LookupService, private globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  SearchModel = {
    GroupID: 0,
    Name: '',
    Mobile: '',
    CurrentIndex: 0,
    PageSize: 20
  };

  ClearSearch() {
    this.GroupContactList=[];
    this.SearchModel.GroupID = 0;
    this.SearchModel.Name = '';
    this.SearchModel.Mobile = '';

  };
  
  SearchGroupContact(){
    this.GroupContactList=[];
    this.currentPage=1;
    this.GetGroupContact();
  }

  GetGroupContact() {
    this.SearchModel.CurrentIndex = this.currentPage;
    this.SearchModel.PageSize = this.pageSize;
    this.spinnerService.show();
    this.SmsService.GetGroupContactDetails(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.GroupContactList = response.GroupContactList;
      if (response.GroupContactList != null && response.GroupContactList.length > 0) {
        this.recordCount = response.GroupContactList[0].RecordCount;
      }

      this.numberOfPages();
      this.spinnerService.hide();
    });
  };

  ContactModel = {
    ContactID: 0,
    GroupID: 0,
    Name: '',
    Mobile: '',
    DOB: '',
    IsActive: true,
  };

  ClearContact() {
    this.ContactModel.GroupID = 0;
    this.ContactModel.Name = '';
    this.ContactModel.Mobile = '';
    this.ContactModel.DOB = '';
    this.ContactModel.IsActive = true;
    this.ContactSubmitted = false;
  };

  ValidDropDown(){
    return this.ContactModel.GroupID==0;
  }
  SaveGroupContact(valid) {
    this.ContactSubmitted = true;
    if (valid && !this.ValidDropDown()) {
      this.ContactModel.DOB = this.ContactModel.DOB != null && this.ContactModel.DOB != '' ? moment(this.ContactModel.DOB).format('DD-MMM-YYYY') : '';
      this.spinnerService.show();
      this.SmsService.SaveGroupContact(JSON.stringify(this.ContactModel)).subscribe((data: any) => {
        this.ContactSubmitted = false;
        if (data.webResponse.Status) {
          this.GetGroupContact();
        }
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }
  };

  ContactMarkActive(item) {
    this.ContactModel.ContactID = item.ContactID;
    this.ContactModel.IsActive = item.IsActive == true ? false : true;
    this.SmsService.ContactMarkActive(JSON.stringify(this.ContactModel)).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.ClearContact();
        this.GetGroupContact();
      }
      this.globalHelper.CheckActionStatus(data);
    });

  };

  Edit(obj) {

    this.ContactModel.GroupID = obj.GroupID;
    this.ContactModel.ContactID = obj.ContactID;
    this.ContactModel.Name = obj.Name;
    this.ContactModel.Mobile = obj.Mobile;
    this.ContactModel.DOB = obj.DOB!=null?moment(obj.DOB).format('DD-MMM-YYYY'):'';

  };

  ngOnInit() {
    this.GetAllGroup();    
  }

  GetAllGroup() {
    this.LookupService.GetLookupsList('SMSGroup', '').subscribe((data: any) => {
      this.GroupDeopDownList = data.LookupItems;
    });

  }

  // Paging


  currentPage: number = 1;
  pageSize: number = 20;
  recordCount: number = 0;
  totalPages: number = 0;

  numberOfPages() {
    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage() {
    this.currentPage = this.currentPage + 1;
  }

  pageSizes() {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;
  }

  // Download


  GroupContactListDownload() {
    this.JSONToCsvConverterContactList(this.GroupContactList, 'Contact_List', true);
  };


  JSONToCsvConverterContactList(JSONData, ReportTitle, ShowLabel) {
    var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
      var row = "";
      row += 'Sr. No.' + ',';
      row += 'Group' + ',';
      row += 'Name' + ',';
      row += 'Mobile' + ',';
      row += 'DOB' + ',';
      row += 'Active' + ',';
      row = row.slice(0, -1);
      CSV += row + '\r\n';
    }
    for (var i = 0; i < arrayData.length; i++) {
      var sno = i + 1;
      var row = "";
      row += '"' + sno + '",';
      if(arrayData[i].GroupName!=null){
        row += '"' + arrayData[i].GroupName + '",';
      }
      else{
        row += '"' + '' + '",';
      }
      if(arrayData[i].Name!=null){
        row += '"' + arrayData[i].Name + '",';
      }
      else{
        row += '"' + '' + '",';
      }
      if(arrayData[i].Mobile!=null){
        row += '"' + arrayData[i].Mobile + '",';
      }
      else{
        row += '"' + '' + '",';
      }
      if(arrayData[i].DOB!=null){
        row += '"' + moment( arrayData[i].DOB).format('DD-MMM-YYYY') + '",';
      }
      else{
        row += '"' + '' + '",';
      }
     
      var Active = '';
      if (arrayData[i].IsActive) {
          Active = 'Yes';
      }
      else {
          Active = 'No';
      }
      row += '"' + Active + '",';
      row.slice(0, row.length - 1);
      CSV += row + '\r\n';
  }
    if (CSV == '') {
      alert('Invalid Data');
      return;
    }
    var FileName = ReportTitle + '_' + moment(new Date()).format('DD-MMM-YYYY');

    var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', FileName + '.csv');
    tempLink.click();
  }

}


